import { ChainIdMismatchError } from '@morpho-org/morpho-sdk'
import {
  isBlueUnknownOfFactoryError,
  UnknownAddressError,
  UnknownBlueFactory,
  UnknownBlueOfFactory,
  UnsupportedBlueVaultV2AdapterError,
  UnsupportedChainIdError
} from '@morpho-org/morpho-sdk/errors'

export const MAX_REALLOCATION_DATA_RETRIES = 3

/** SDK planning errors that no retry can fix (registry gaps, non-Vault-V2 candidates, chain mismatch). */
export const isDeterministicReallocationError = (error: unknown): boolean =>
  isBlueUnknownOfFactoryError(error) ||
  error instanceof UnknownBlueOfFactory ||
  error instanceof UnknownBlueFactory ||
  error instanceof UnsupportedChainIdError ||
  error instanceof UnknownAddressError ||
  error instanceof UnsupportedBlueVaultV2AdapterError ||
  error instanceof ChainIdMismatchError

export const shouldRetryReallocationData = (failureCount: number, error: Error): boolean =>
  !isDeterministicReallocationError(error) && failureCount < MAX_REALLOCATION_DATA_RETRIES
